<template>
  <ul class="example-sentence-list">
    <li v-if="isYagiPrime" class="example-sentence-item">
      <p class="question-title">⓪ 応募先企業のURL（任意）</p>
      <ai-mypr-company-url-field
        :url="String(formatData.ai_company_url || '')"
        :company-name="String(formatData.ai_company_name || '')"
        :industry="String(formatData.hopeIndustrycategory || '')"
        :job="String(formatData.hopeJobcategory || '')"
        :values="String(formatData.ai_company_values || '')"
        :extracting="extracting"
        :extracted="extracted"
        @update:url="emitUpdate('ai_company_url', $event)"
        @update:companyName="emitUpdate('ai_company_name', $event)"
        @update:industry="emitUpdate('hopeIndustrycategory', $event)"
        @update:job="emitUpdate('hopeJobcategory', $event)"
        @update:values="emitUpdate('ai_company_values', $event)"
        @extract="$emit('extract')"
      />
    </li>
    <li class="example-sentence-item">
      <p class="question-title">① 得意なこと <span>必須</span></p>
      <div class="el-textarea">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5 }"
          placeholder="英語、プログラミング、コミュニケーション、Wordなど"
          title="得意なこと"
          autocomplete="off"
          :value="String(formatData.ai_strength || '')"
          @input="emitUpdate('ai_strength', $event)"
        />
      </div>
    </li>
    <li class="example-sentence-item">
      <p class="question-title">② 希望企業名</p>
      <div class="el-textarea">
        <el-input
          type="text"
          autosize
          placeholder="株式会社Yagish"
          title="希望企業名"
          autocomplete="off"
          :value="String(formatData.ai_company_name || '')"
          @input="emitUpdate('ai_company_name', $event)"
        />
      </div>
    </li>
    <li class="example-sentence-item">
      <div v-if="layout === 'panel'" class="paired-fields">
        <div class="paired-field">
          <p class="question-title">③ 希望業界</p>
          <div class="el-textarea">
            <label class="selectbox-3">
              <select
                :value="String(formatData.hopeIndustrycategory || '')"
                @change="onSelectChange('hopeIndustrycategory', $event)"
              >
                <option
                  v-for="item in hopeIndustryOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </div>
        </div>
        <div class="paired-field">
          <p class="question-title sub-question-title">
            現在のあなたのいる業界
          </p>
          <div class="el-textarea">
            <label class="selectbox-3">
              <select
                :value="String(formatData.currentIndustrycategory || '')"
                @change="onSelectChange('currentIndustrycategory', $event)"
              >
                <option
                  v-for="item in hopeIndustryOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </div>
      <template v-else>
        <p class="question-title">③ 希望業界</p>
        <div class="el-textarea">
          <label class="selectbox-3">
            <select
              :value="String(formatData.hopeIndustrycategory || '')"
              @change="onSelectChange('hopeIndustrycategory', $event)"
            >
              <option
                v-for="item in hopeIndustryOptions"
                :key="item"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </label>
        </div>
        <p class="question-title sub-question-title">現在のあなたのいる業界</p>
        <div class="el-textarea">
          <label class="selectbox-3">
            <select
              :value="String(formatData.currentIndustrycategory || '')"
              @change="onSelectChange('currentIndustrycategory', $event)"
            >
              <option
                v-for="item in hopeIndustryOptions"
                :key="item"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </label>
        </div>
      </template>
    </li>
    <li class="example-sentence-item">
      <div v-if="layout === 'panel'" class="paired-fields">
        <div class="paired-field">
          <p class="question-title">④ 希望職種</p>
          <div class="el-textarea">
            <label class="selectbox-3">
              <select
                :value="String(formatData.hopeJobcategory || '')"
                @change="onSelectChange('hopeJobcategory', $event)"
              >
                <option
                  v-for="item in hopeJobcategoryOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </div>
        </div>
        <div class="paired-field">
          <p class="question-title sub-question-title">
            現在のあなたのいる職種
          </p>
          <div class="el-textarea">
            <label class="selectbox-3">
              <select
                :value="String(formatData.currentJobcategory || '')"
                @change="onSelectChange('currentJobcategory', $event)"
              >
                <option
                  v-for="item in hopeJobcategoryOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </div>
      <template v-else>
        <p class="question-title">④ 希望職種</p>
        <div class="el-textarea">
          <label class="selectbox-3">
            <select
              :value="String(formatData.hopeJobcategory || '')"
              @change="onSelectChange('hopeJobcategory', $event)"
            >
              <option
                v-for="item in hopeJobcategoryOptions"
                :key="item"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </label>
        </div>
        <p class="question-title sub-question-title">現在のあなたのいる職種</p>
        <div class="el-textarea">
          <label class="selectbox-3">
            <select
              :value="String(formatData.currentJobcategory || '')"
              @change="onSelectChange('currentJobcategory', $event)"
            >
              <option
                v-for="item in hopeJobcategoryOptions"
                :key="item"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </label>
        </div>
      </template>
    </li>
    <slot name="cta" />
    <li v-if="!isYagiPrime" class="example-sentence-item">
      <p class="question-title">⓪ 応募先企業のURL（任意）</p>
      <div class="ai-company-url-locked">
        <el-input disabled placeholder="🔒 プライム会員のみ" />
        <p class="ai-company-url-locked__desc">
          企業HPのURLから、AIが求める人物像を自動分析。企業の理念や社風に合わせた、より通過率の高い志望動機を作成できます。
        </p>
        <button
          type="button"
          class="ai-company-url-locked__cta"
          @click="$emit('prime-cta')"
        >
          👑 プライム会員になってこの機能を使う
        </button>
      </div>
    </li>
    <li class="example-sentence-item example-sentence-item--self">
      <p class="question-title ai-mypr-self-title">
        以下の履歴書内容も文章作成の際に参考にしています。<br />最終学歴、最終職歴、取得資格、入力されている志望動機
      </p>
      <p class="question-title">
        {{ formatData.lastestEdu ? '最終学歴' : '最終学歴を教えてください' }}
      </p>
      <div class="el-textarea">
        <el-input
          type="textarea"
          autosize
          title="最終学歴"
          autocomplete="off"
          :value="String(formatData.lastestEdu || '')"
          @input="emitUpdate('lastestEdu', $event)"
        />
      </div>
      <p class="question-title">
        {{ formatData.lastestJob ? '最終職歴' : '最終職歴を教えてください' }}
      </p>
      <div class="el-textarea">
        <el-input
          type="textarea"
          autosize
          title="最終職歴"
          autocomplete="off"
          :value="String(formatData.lastestJob || '')"
          @input="emitUpdate('lastestJob', $event)"
        />
      </div>
      <p class="question-title">
        {{ licences ? '取得資格' : '取得資格を教えてください' }}
      </p>
      <div class="el-textarea">
        <p style="font-size: 13px">{{ licences }}</p>
      </div>
      <p class="question-title">
        {{ formatData.reason ? '志望動機' : '志望動機を教えてください' }}
      </p>
      <div class="el-textarea">
        <p class="reason-txt">{{ formatData.reason }}</p>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import AiMyprCompanyUrlField from '@/components/yagiprime/AiMyprCompanyUrlField.vue'

defineProps<{
  formatData: Record<string, unknown>
  hopeIndustryOptions: string[]
  hopeJobcategoryOptions: string[]
  isYagiPrime: boolean
  extracting: boolean
  extracted: boolean
  licences: string
  layout?: 'dialog' | 'panel'
}>()

const emit = defineEmits<{
  (e: 'update-field', payload: { key: string; value: unknown }): void
  (e: 'extract'): void
  (e: 'prime-cta'): void
}>()

function emitUpdate(key: string, value: unknown) {
  emit('update-field', { key, value })
}

function onSelectChange(key: string, event: Event) {
  const target = event.target
  if (!(target instanceof HTMLSelectElement)) return
  emitUpdate(key, target.value)
}
</script>
